export default __webpack_public_path__ + "static/Group 1951-738ad347c8e7221405f0597fe827f3f5.png";